import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import api from "@/lib/api";
import { toast } from "sonner";
import { Users, TrendingUp, IndianRupee, Copy, Loader2 } from "lucide-react";

export default function PartnerDashboard() {
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/partner/me").then((r) => setPartner(r.data)).finally(() => setLoading(false));
  }, []);

  const copyLink = () => {
    navigator.clipboard.writeText(partner.referral_link);
    toast.success("Link copied");
  };

  if (loading) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <div className="max-w-5xl mx-auto px-4 py-12 flex items-center gap-2 text-sm label-mono">
          <Loader2 className="animate-spin" size={16} /> Loading…
        </div>
      </div>
    );
  }

  const cards = [
    { label: "Signups", value: partner?.signups ?? 0, icon: Users, color: "bg-[#E9D5FF]" },
    { label: "Paid Conversions", value: partner?.paid_conversions ?? 0, icon: TrendingUp, color: "bg-[#A7F3D0]" },
    { label: "Revenue Generated", value: `₹${(partner?.revenue ?? 0).toFixed(2)}`, icon: IndianRupee, color: "bg-[#FEF08A]" },
  ];

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-10">
        <span className="label-mono">Partner</span>
        <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tighter mt-2">Your Dashboard</h1>
        <p className="text-[#52525B] mt-2">Share your link — every referral gets ₹100 off, and you earn credit for the conversion.</p>

        <div className="mt-8 card-brutal p-6 bg-white flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
          <input
            data-testid="partner-referral-link"
            readOnly
            value={partner?.referral_link || ""}
            className="flex-1 px-4 py-3 border-2 border-[#0A0A0A] rounded-xl bg-[#F4F4F5] font-mono text-sm"
          />
          <button onClick={copyLink} data-testid="partner-copy-link" className="btn-brutal bg-blue-600 text-white px-4 py-3 text-sm flex items-center justify-center gap-2">
            <Copy size={14} strokeWidth={2.5} /> Copy link
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          {cards.map((c) => (
            <div key={c.label} data-testid={`partner-stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`} className={`card-brutal p-8 ${c.color}`}>
              <c.icon strokeWidth={2.5} size={28} />
              <div className="label-mono mt-4">{c.label}</div>
              <div className="font-display text-4xl font-extrabold tracking-tight mt-2">{c.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
